module.exports = require("wix-storage");